import { Inject, Injectable } from '@rxdi/core';
import { map, take } from 'rxjs/operators';

import { UserService } from './user.service';

@Injectable()
export class UserScopeService {
  @Inject(UserService)
  private userService: UserService;
  canViewProfileSession() {
    return this.userService.getUserOnce().pipe(map((u) => !!u.scopes?.includes('CAN_VIEW_PROFILE_SESSIONS')));
  }

  canListAllUsers() {
    return this.userService.getUserOnce().pipe(map((u) => !!u.scopes?.includes('CAN_LIST_ALL_USERS')));
  }

  canViewApps() {
    return this.userService.getUserOnce().pipe(
      take(1),
      map((u) => !!u.scopes?.includes('CAN_VIEW_APPS'))
    );
  }
}
